import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// PASTE YOUR CONFIG FROM FIREBASE CONSOLE HERE
const firebaseConfig = {
  apiKey: "AIzaSyDFJ4LAUsrY2mSGYt8szCgdJYCOXPKmM0M",
  authDomain: "nettic-dashboard.firebaseapp.com",
  projectId: "nettic-dashboard",
  storageBucket: "nettic-dashboard.firebasestorage.app",
  messagingSenderId: "148097627004",
  appId: "1:148097627004:web:7170f38dd699da81cf6af9"
};

const app = initializeApp(firebaseConfig);
export { app };

export const db = getFirestore(app);

export const storage = getStorage(app);
export const auth = getAuth(app);